import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import '../../index.css';

const initialData = [
  { id: 1, session: "2021-2022", className: "I", status: "Active" },
  { id: 2, session: "2022-2023", className: "SCHOOL", status: "Active" },
  { id: 3, session: "2022-2023", className: "I - RTE", status: "Active" },
];

export default function ClassFee() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState("");

  //  FIX 1: Load with fallback
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("classFee"));

    if (saved && saved.length > 0) {
      setList(saved);
    } else {
      setList(initialData);
      localStorage.setItem("classFee", JSON.stringify(initialData));
    }
  }, []);

  //  FIX 2: Refresh when coming back from form
  useEffect(() => {
    const handleFocus = () => {
      const saved = JSON.parse(localStorage.getItem("classFee")) || [];
      setList(saved);
    };

    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, []);

  //  FILTER (safe)
  const filtered = list.filter((item) =>
    (item.className || "").toLowerCase().includes(search.toLowerCase())
  );

  //  DELETE (FIXED)
  const handleDelete = () => {
    if (!selected) return alert("Select row first");

    const updated = list.filter((l) => l.id !== selected.id);

    setList(updated);
    localStorage.setItem("classFee", JSON.stringify(updated));
    setSelected(null);
  };

  return (
    <>

      <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header {
          display:flex;
          justify-content:space-between;
          margin-bottom:10px;
        }

        .controls {
          display:flex;
          gap:10px;
          margin-bottom:10px;
          flex-wrap:wrap;
        }

        .search-box {
          padding:8px;
          border:1px solid #ccc;
          border-radius:4px;
        }

        .btn {
          padding:7px 12px;
          border:none;
          border-radius:4px;
          cursor:pointer;
        }

        .btn-dark { background:#2c3e50; color:#fff; }
        .btn-blue { background:#3498db; color:#fff; }
        .btn-red { background:#e74c3c; color:#fff; }

        table {
          width:100%;
          border-collapse:collapse;
        }

        th, td {
          padding:10px;
          border-bottom:1px solid #eee;
        }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }
        input[type="checkbox"] { cursor:pointer; }
      `}</style>

      <div className="page">
        <div className="card">

          <div className="header">
            <h3>Class Fee</h3>
            <div>{list.length} Records</div>
          </div>

          <div className="controls">

            <input
              className="search-box"
              placeholder="Search Class"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <button
              className="btn btn-dark"
              onClick={() => navigate("/admin/classfee/add")}
            >
              + Add
            </button>

            <button
              className="btn btn-blue"
              onClick={() => {
                if (!selected) return alert("Select row first");
                navigate(`/admin/classfee/edit/${selected.id}`);
              }}
            >
              Update
            </button>

            <button className="btn btn-red" onClick={handleDelete}>
              Delete
            </button>
          </div>

          <table>
            <thead>
              <tr>
                <th></th>
                <th>Session</th>
                <th>Class</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item) => (
                <tr
                  key={item.id}
                  className={selected?.id === item.id ? "active-row" : ""}
                  onClick={() => setSelected(item)}
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selected?.id === item.id}
                      onChange={() => setSelected(item)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>

                  <td>{item.session}</td>
                  <td>{item.className}</td>
                  <td>{item.status}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </div>
    </>
  );
}